import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

export const skipThread = (): Observable<boolean> => {
  // use delay(0) to make a real async Observable outside angular main thread`
  const asyncObservable: Observable<boolean> = of(true).pipe(delay(0));

  return asyncObservable;
};
